module.exports = __webpack_public_path__ + "img/panda.277ea487.png";